export default () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.5 4C2.67157 4 2 4.67157 2 5.5V14.5C2 15.3284 2.67157 16 3.5 16H16.5C17.3284 16 18 15.3284 18 14.5V5.5C18 4.67157 17.3284 4 16.5 4H3.5ZM16.5 5.5V6.027L10.5727 9.81818C10.2222 10.0367 9.77783 10.0367 9.42734 9.81818L3.5 6.027V5.5H16.5ZM3.5 7.13821L8.97468 10.5679C9.57266 10.9424 10.4273 10.9424 11.0253 10.5679L16.5 7.13821V14.5H3.5V7.13821Z'
      fill='#5A607F'
    />
  </svg>
);
